export default __webpack_public_path__ + "static/media/assessment_design.80403942.jpg";